import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../StuStyles/StudentProfile.css";
import { useNavigate, useLocation } from "react-router-dom";
import { TiArrowBack } from "react-icons/ti";
import ApiService from "../../../nhrc_apis/ApiService";

const AdminAPI = ApiService.AdminAPI;
const UploadAPI = ApiService.UploadAPI;

// ✅ No need to redeclare BASE_URL — but kept here only for building
// direct <img src> URLs (img tags don't go through axios)
const BASE_URL = "https://nhrc.onrender.com";

const EmployeeapproveView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const membershipId = location.state?.membershipId;

  const [employee, setEmployee] = useState(null);
  const [details, setDetails] = useState(null);
  const [uploads, setUploads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(function () {
    if (membershipId) {
      fetchAll();
    } else {
      setLoading(false);
    }
  }, [membershipId]);

  function fetchAll() {
    Promise.allSettled([
      AdminAPI.getMemberById(membershipId),
      UploadAPI.getUploadedFiles(membershipId),
    ]).then(function (results) {
      var memberRes = results[0];
      var uploadRes = results[1];

      if (memberRes.status === "fulfilled") {
        var memberData = memberRes.value?.data?.member || {};
        var detailData = memberRes.value?.data?.details || {};
        setEmployee(memberData);
        setDetails(detailData);
      } else {
        console.error("MEMBER FETCH ERROR:", memberRes.reason);
      }

      if (uploadRes.status === "fulfilled") {
        var data = uploadRes.value?.data;
        var fileList = Array.isArray(data) ? data : (data?.files || []);
        setUploads(fileList);
      } else {
        console.warn("UPLOAD FETCH ERROR:", uploadRes.reason);
        setUploads([]);
      }

      setLoading(false);
    }).catch(function (err) {
      console.error("FETCH ERROR:", err);
      setLoading(false);
    });
  }

  // ✅ BASE_URL is needed here because <img src> is NOT an axios call
  // It's a direct browser request, so axios baseURL does NOT apply
  function buildUrl(path) {
    if (!path) return "";
    if (path.startsWith("http")) return path;
    return BASE_URL + "/" + path.replace(/^\/+/, "");
  }

  function isImage(path) {
    if (!path) return false;
    return /\.(jpg|jpeg|png|webp|gif)$/i.test(path);
  }

  function isPdf(path) {
    if (!path) return false;
    return /\.pdf$/i.test(path);
  }

  // ✅ FIX: API returns "file_path" not "file_url" or "path"
  function getFileUrl(f) {
    var raw = "";
    if (f && f.file_path) raw = f.file_path;       // ✅ correct key
    else if (f && f.file_url) raw = f.file_url;
    else if (f && f.path) raw = f.path;
    else if (typeof f === "string") raw = f;
    return buildUrl(raw);
  }

  function getFileName(f) {
    if (f && f.file_name) return f.file_name;
    if (f && f.name) return f.name;
    var raw = "";
    if (f && f.file_path) raw = f.file_path;       // ✅ correct key
    else if (f && f.file_url) raw = f.file_url;
    else if (f && f.path) raw = f.path;
    else if (typeof f === "string") raw = f;
    var parts = raw.split("/");
    return parts[parts.length - 1] || raw;
  }

  // ✅ FIX: filter using f.file_path (correct key from API)
  // ✅ FIX: exclude profile image from the images grid
  var imageFiles = uploads.filter(function (f) {
    var raw = (f && f.file_path) || "";
    return isImage(raw) && f.file_type !== "profile";
  });

  var pdfFiles = uploads.filter(function (f) {
    var raw = (f && f.file_path) || "";
    return isPdf(raw);
  });

  var idCardFiles = uploads.filter(function (f) {
    return f && (f.file_type === "employee_id" || f.file_type === "id_card");
  });

  // ✅ FIX: profile pic comes from uploads array (file_type === "profile")
  // because employee.profile_pic is null in your API response
  var profileUpload = uploads.find(function (f) {
    return f && f.file_type === "profile";
  });

  if (!membershipId) {
    return (
      <div className="container mt-5 text-center">
        <h4>No Membership ID found</h4>
        <button className="btn btn-primary mt-3" onClick={function () { navigate(-1); }}>
          Go Back
        </button>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="container mt-5 text-center">
        <h5>Loading...</h5>
      </div>
    );
  }

  if (!employee) {
    return (
      <div className="container mt-5 text-center">
        <h4>No employee data found</h4>
        <button className="btn btn-primary mt-3" onClick={function () { navigate(-1); }}>
          Go Back
        </button>
      </div>
    );
  }

  // ✅ FIX: first check uploads array for profile, then fallback to employee.profile_pic
  var profileSrc = profileUpload
    ? buildUrl(profileUpload.file_path)
    : employee.profile_pic
    ? buildUrl(employee.profile_pic)
    : "https://dummyimage.com/150x150/cccccc/000000&text=No+Image";

  return (
    <div className="container student-profile-container mt-5 mb-0">

      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="fw-bold mt-3">EMPLOYEE DETAILS</h4>
      </div>

      <button className="jobback mb-3" onClick={function () { navigate(-1); }}>
        <TiArrowBack /> Back
      </button>

      {/* Personal Details */}
      <div className="card p-3 mb-4">
        <h5 className="text-center">Personal Details</h5>
        <div className="row g-3 mt-2">

          <div className="col-md-4">
            <label className="empv-label">Profile Photo</label>
            <div>
              <img
                src={profileSrc}
                alt="profile"
                className="img-fluid profile-pic"
                style={{ maxHeight: "180px", objectFit: "cover", borderRadius: "8px" }}
                onError={function (e) {
                  e.target.src = "https://dummyimage.com/150x150/cccccc/000000&text=No+Image";
                }}
              />
            </div>
          </div>

          <div className="col-md-4">
            <label className="empv-label">Full Name</label>
            <input className="form-control" value={employee.full_name || ""} readOnly />
          </div>

          <div className="col-md-4">
            <label className="empv-label">Email</label>
            <input className="form-control" value={employee.email || ""} readOnly />
          </div>

          <div className="col-md-4">
            <label className="empv-label">Mobile</label>
            <input className="form-control" value={employee.mobile || ""} readOnly />
          </div>

          <div className="col-md-4">
            <label className="empv-label">Gender</label>
            <input className="form-control" value={employee.gender || ""} readOnly />
          </div>

          <div className="col-md-4">
            <label className="empv-label">DOB</label>
            <input className="form-control" value={employee.dob || ""} readOnly />
          </div>

          <div className="col-md-4">
            <label className="empv-label">Blood Group</label>
            <input className="form-control" value={employee.blood_group || ""} readOnly />
          </div>

          <div className="col-md-4">
            <label className="empv-label">State</label>
            <input className="form-control" value={employee.state || ""} readOnly />
          </div>

          <div className="col-md-4">
            <label className="empv-label">District</label>
            <input className="form-control" value={employee.district || ""} readOnly />
          </div>

          <div className="col-md-4">
            <label className="empv-label">Pincode</label>
            <input className="form-control" value={employee.pincode || ""} readOnly />
          </div>

        </div>
      </div>

      {/* Employee Details */}
      <div className="card p-3 mb-4">
        <h5 className="text-center">Employee Details</h5>
        <div className="row g-3 mt-2">

          <div className="col-md-4">
            <label className="empv-label">Membership ID</label>
            <input className="form-control" value={employee.membership_id || ""} readOnly />
          </div>

          <div className="col-md-4">
            <label className="empv-label">Employee ID</label>
            <input className="form-control" value={(details && details.employee_id) || ""} readOnly />
          </div>

          <div className="col-md-4">
            <label className="empv-label">Designation</label>
            <input className="form-control" value={(details && details.designation) || ""} readOnly />
          </div>

          <div className="col-md-4">
            <label className="empv-label">Department</label>
            <input className="form-control" value={(details && details.department) || ""} readOnly />
          </div>

          <div className="col-md-4">
            <label className="empv-label">Organization Name</label>
            <input className="form-control" value={(details && details.organization_name) || ""} readOnly />
          </div>

          <div className="col-md-4">
            <label className="empv-label">Official Email</label>
            <input className="form-control" value={(details && details.official_email) || ""} readOnly />
          </div>

          <div className="col-md-4">
            <label className="empv-label">Industry</label>
            <input className="form-control" value={(details && details.industry) || ""} readOnly />
          </div>

          <div className="col-md-4">
            <label className="empv-label">Experience</label>
            <input className="form-control" value={(details && details.experience) || ""} readOnly />
          </div>

          <div className="col-md-4">
            <label className="empv-label">Working Location</label>
            <input className="form-control" value={(details && details.working_location) || ""} readOnly />
          </div>

          <div className="col-md-4">
            <label className="empv-label">Company Website</label>
            <input className="form-control" value={(details && details.company_website) || ""} readOnly />
          </div>

          <div className="col-md-4">
            <label className="empv-label">Company Strength</label>
            <input className="form-control" value={(details && details.company_strength) || ""} readOnly />
          </div>

          <div className="col-md-4">
            <label className="empv-label">Referral ID</label>
            <input className="form-control" value={(details && details.referral_id) || ""} readOnly />
          </div>

          <div className="col-md-4">
            <label className="empv-label">Role</label>
            <input className="form-control" value={employee.role || ""} readOnly />
          </div>

          <div className="col-md-4">
            <label className="empv-label">Status</label>
            <input className="form-control" value={employee.status || ""} readOnly />
          </div>

          <div className="col-md-4">
            <label className="empv-label">Candidate Type</label>
            <input className="form-control" value={employee.candidate_type || ""} readOnly />
          </div>

          <div className="col-md-4">
            <label className="empv-label">WhatsApp Notification</label>
            <input
              className="form-control"
              value={
                employee.whatsapp_notification !== undefined && employee.whatsapp_notification !== null
                  ? String(employee.whatsapp_notification)
                  : ""
              }
              readOnly
            />
          </div>

          <div className="col-md-4">
            <label className="empv-label">Created At</label>
            <input className="form-control" value={employee.created_at || ""} readOnly />
          </div>

          <div className="col-md-4">
            <label className="empv-label">Approved At</label>
            <input className="form-control" value={employee.approved_at || ""} readOnly />
          </div>

          <div className="col-md-4">
            <label className="empv-label">Rejected At</label>
            <input className="form-control" value={employee.rejected_at || ""} readOnly />
          </div>

        </div>
      </div>

      {/* ID Card Section */}
      {idCardFiles.length > 0 && (
        <div className="card p-3 mb-4">
          <h5 className="text-center mb-3">ID Card</h5>
          <div className="row g-3">
            {idCardFiles.map(function (f, i) {
              return (
                <div className="col-md-4 col-sm-6" key={i}>
                  <div className="border rounded p-1 text-center">
                    <img
                      src={getFileUrl(f)}
                      alt={getFileName(f)}
                      className="img-fluid rounded"
                      style={{ maxHeight: "200px", objectFit: "cover", width: "100%" }}
                      onError={function (e) {
                        e.target.src = "https://dummyimage.com/300x200/cccccc/000000&text=No+Image";
                      }}
                    />
                    <p className="mt-1 mb-0 text-truncate" style={{ fontSize: "0.72rem", color: "#555" }} title={getFileName(f)}>
                      {getFileName(f)}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Other Uploaded Images */}
      <div className="card p-3 mb-4">
        <h5 className="text-center mb-3">Uploaded Images</h5>
        <div className="row g-3">
          {imageFiles.length === 0 && (
            <p className="text-center text-muted">No images uploaded.</p>
          )}
          {imageFiles.length > 0 && imageFiles.map(function (f, i) {
            return (
              <div className="col-md-3 col-sm-4 col-6" key={i}>
                <div className="border rounded p-1 text-center">
                  <img
                    src={getFileUrl(f)}
                    alt={getFileName(f)}
                    className="img-fluid rounded"
                    style={{ maxHeight: "160px", objectFit: "cover", width: "100%" }}
                    onError={function (e) {
                      e.target.src = "https://dummyimage.com/150x150/cccccc/000000&text=No+Image";
                    }}
                  />
                  <p className="mt-1 mb-0 text-truncate" style={{ fontSize: "0.72rem", color: "#555" }} title={getFileName(f)}>
                    {getFileName(f)}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* PDF Documents */}
      <div className="card p-3 mb-4">
        <h5 className="text-center mb-3">Uploaded Documents</h5>
        <div className="row g-3">
          {pdfFiles.length === 0 && (
            <p className="text-center text-muted">No documents uploaded.</p>
          )}
          {pdfFiles.length > 0 && pdfFiles.map(function (f, i) {
            var fileUrl = getFileUrl(f);
            var fileName = getFileName(f);
            return (
              <div className="col-md-4 col-sm-6" key={i}>
                <div className="border rounded p-3 d-flex align-items-center gap-2">
                  <span style={{ fontSize: "1.8rem" }}>📄</span>
                  <div style={{ overflow: "hidden" }}>
                    <p className="mb-1 text-truncate fw-semibold" style={{ fontSize: "0.82rem" }} title={fileName}>
                      {fileName}
                    </p>
                    <a href={fileUrl} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-primary">
                      View PDF
                    </a>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

    </div>
  );
};

export default EmployeeapproveView;